export class GetTeamActiveCalls {
    static readonly type = '[AdminPhoneToolsState] GetTeamActiveCalls';
    constructor() {}
}

export class ClearTeamActiveCalls {
    static readonly type = '[AdminPhoneToolsState] ClearTeamActiveCalls';
    constructor(public teamId: number) {}
}

export class SubscribeToTeamActiveCalls {
    static readonly type = '[AdminPhoneToolsState] SubscribeToTeamActiveCalls';
    constructor(public teamId: number) {}
}
